import CardServiceComponent from '../components/card-service/cardService.jsx';

const CardService = () => <CardServiceComponent />;

export default CardService;
